import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useNextLesson from "@/helpers/jw-helpers/next-lesson";
import useResponsive from "@/utils/hooks/Responsive-Screens";

export default function Video({
  data,
  close,
  setClose,
  playerRef,
  videoEntry,
  videoConfig,
  videoData,
  isStandaloneCourse,
  lpTitle,
  isLpPreviewVideo,
  isLesson,
  isLast,
  inCompletedLessons,
  isCourseDetailsPage = false,
  transcriptions_captions,
}) {
  
  const [subtitleUrl, setSubtitleUrl] = useState(null);
  
  useEffect(() => {
    if (transcriptions_captions?.subtitles) {
      const vttData = transcriptions_captions.subtitles;
      const blob = new Blob([vttData], { type: "text/vtt" });
      const url = URL.createObjectURL(blob);
      setSubtitleUrl(url);
      
      // Cleanup function to prevent memory leaks
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [transcriptions_captions?.subtitles]);

  const router = useRouter();
  const { isMobile, isTablet } = useResponsive();
  // Handle both course and learning path URLs
  let pathname = router.asPath
    .replace(/^.*\/(courses|learning-paths\/[^/]+\/[^/]+)\//, "/")
    .replace(/\?.*$/, "");

  const nextLesson = useNextLesson(videoConfig, router, null, true);

  const [next] = useState(
    videoConfig
      ? Object.values(videoConfig).findIndex((x) =>
          x.url.endsWith(pathname) ? x.url : 0
        ) + 1
      : 1
  );
  const [showNextLesson, setShowNextLesson] = useState(false);
  useEffect(() => {
    const shouldShowNext =
      !isStandaloneCourse &&
      videoConfig &&
      !isLast &&
      inCompletedLessons?.length !== 1;

    setShowNextLesson(shouldShowNext);
  }, [isStandaloneCourse, videoConfig, isLast, inCompletedLessons?.length]);

  const handleCloseNextLesson = (e) => {
    setShowNextLesson(false);
    nextLesson();
  };

  return (
    <div
      className="video-container"
      style={{ margin: "16px" }}
    >
      <div className={`video-src ${isStandaloneCourse ? "standalone" : ""}`}>
        {videoData?.file ? (
          <div
            className="jwplayer-inject"
            ref={playerRef}
            data-caption-url={subtitleUrl}
            data-caption-label="English"
            data-caption-lang="en"
          >
            {/* JWPlayer */}
          </div>
        ) : (
          <img
            src={videoData?.image}
            alt={videoEntry?.title || "Course preview image"}
            style={{ width: "100%" }}
          />
        )}

        {/* {videoEntry?.text_lesson && <TextLesson title={data.title} content={videoEntry.text_lesson} videoConfig={videoConfig} />} */}
        {/* {videoEntry?.text_lesson && <TextLessonPage title={data.title} content={videoEntry.text_lesson} videoConfig={videoConfig} />} */}

        {(!isLpPreviewVideo || videoData?.file) && !videoData.hideHeader && (
          <div className="video-header-container">
            <div className="video-header">
              {!isCourseDetailsPage && (isMobile || isTablet || !close) && (
                <button
                  className="side-nav-toggle"
                  onClick={() => setClose(!close)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 6H21"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 12H21"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 18H21"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 6H3.01"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 12H3.01"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 18H3.01"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              )}
              {isStandaloneCourse && (
                <span
                  className="text-capitalize cs-pl-24"
                  data-swiftype-index="false"
                >
                  {data?.title}{" "}
                </span>
              )}
              {!isStandaloneCourse ? (
                isLpPreviewVideo ? (
                  videoData?.file ? (
                    <span
                      className="text-capitalize fw-normal cs-pl-24"
                      data-swiftype-index="false"
                    >
                      {"Preview"} {"-"} {data?.title}
                    </span>
                  ) : null
                ) : (
                  <span
                    className="text-capitalize fw-normal cs-pl-24"
                    data-swiftype-index="false"
                  >
                    {data?.title}
                    {isLesson ? (
                      <em className="">
                        {" - "}
                        {videoEntry?.coverTitle || videoEntry?.title}
                      </em>
                    ) : (
                      <em className="">
                        {" - "}
                        {lpTitle
                          ? lpTitle
                          : videoEntry?.coverTitle || videoEntry?.title}
                      </em>
                    )}
                  </span>
                )
              ) : null}
            </div>
          </div>
        )}

        {showNextLesson && !isStandaloneCourse && videoConfig && !isLast && (
          <div
            className="next-lesson-container"
            data-swiftype-index="false"
          >
            <div className="next-lesson">
              <div
                className="nextup-header"
                onClick={nextLesson}
              >
                <div className="nextup-heading">Up next</div>
                <div className="nextup-title">{videoConfig[next]?.title}</div>
              </div>

              <div className="nextup-icon loader"></div>
              <div
                className="nextup-cancel"
                onClick={handleCloseNextLesson}
              >
                Cancel
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
